<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <v-col cols="12">
      <base-material-card
        color="coolrunner"
        :icon="icon"
        inline
        class="px-5 py-3"
      >
        <template v-slot:after-heading>
          <div class="text-h2 font-weight-light">
            {{ $t('duplicate_label') }}
          </div>
        </template>

        <v-col style="text-align: center;">
          <input
            v-model="code"
            style="font-size: 32px; border: 2px solid grey; padding: 10px 5px; width: 100%; border-radius: 10px; text-align: center"
            :placeholder="$t('enter_package_number')"
            @keypress.enter="scan"
          >
          <v-btn
            class="mt-2 ml-auto"
            color="primary"
            large
            :disabled="!code || loading"
            :loading="loading"
            @click="scan"
          >
            {{ $t('scan') }}
          </v-btn>
        </v-col>
      </base-material-card>
    </v-col>
    <base-loading-overlay :loading="loadingPdf" />
  </v-container>
</template>

<script>
  import Auth from '@/mixins/Auth'
  import { handleErrorResponse } from '@/plugins/data'
  import print from 'print-js'
  import { PCN } from '../../../utils/constants'

  export default {
    mixins: [Auth],
    data () {
      return {
        crudl: {
          C: PCN.val,
          R: PCN.val,
          U: PCN.val,
          D: PCN.val,
          L: PCN.val,
          COOLRUNNER_ONLY: false,
        },
        endpoint: 'duplicate-label',
        name: 'duplicate-label',
        icon: 'mdi-truck-fast-outline',
        code: '',
        loading: false,
        loadingPdf: false,
      }
    },
    methods: {
      scan: function () {
        this.loading = true
        if (this.code.length === 8 && !isNaN(this.code)) {
          const chunks = this.code.match(/.{1,2}/g)
          this.code = `HR-${chunks.join('-')}`
        }

        this.$axios.get(`${this.endpoint}/${this.code}`, { responseType: 'blob' })
          .then((r) => {
            print({
              printable: URL.createObjectURL(r.data),
              type: 'pdf',
              onPrintDialogClose: () => { this.loadingPdf = null },
              onPdfOpen: () => { this.loadingPdf = null },
              onError: handleErrorResponse,
            })
            this.code = ''
            this.$playSound('/sounds/success.mp3')
          })
          .catch(e => {
            if (e.response.status === 500) {
              this.$toast('Pakkenummeret findes ikke i listen')
              this.code = ''
            }
          })
          .finally(() => {
            this.loadingPdf = null
            this.loading = false
          })
      },
    },
  }
</script>
